export default "__VITE_ASSET__MsHK9LqZ__"